import React from "react";

import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { MRC2Section } from "../index";


function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  setGenerateMRC2,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  return (
    <FormSection
      disableAll={disableAll}
      sectionName='MRC2'
      formikRef={formikRef}
      questionnaire={globalQuestionnaire}
      setQuestionnaire={setGlobalQuestionnaire}
      values={{...formikProps.values, showDescription: true}}
      error={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      onQuestionChange={(
        question,
        value,
        setFieldValue,
        questionnaireUpdated,
      ) =>
        MRC2Section.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaire: setGlobalQuestionnaire,
          setFieldValue,
          setGenerateMRC2,
          questionnaireAnswersToDelete,
          setQuestionnaireAnswersToDelete,
          documentsToDelete,
          setDocumentsToDelete
        })
      }
    />
  )
}

const components = {
  RenderSection
};

export { components };